import { string } from "mathjs";

export class MemoryFeatureRepo {
    constructor(data){
        this.data=data
    }
    got_feature(feat, user, cdb_type_value){
        
        if(!user && !cdb_type_value){
            return this.data[feat];
        }
        if(user && !cdb_type_value){
            return this.data[feat+'@'+user.username];
        }
        return this.data[feat+'@'+user.username+'@'+cdb_type_value]
    }
}

export class VueFeatureRepository {
    constructor(got_feature_func){
        this.got_feature=got_feature_func
    }
   
}

